(function () {
  var root = document.getElementById('notb-master');
  if (!root) return;
  var L = root.getAttribute('data-lang') === 'en' ? 'en' : 'nl', loc = L === 'nl' ? 'nl-NL' : 'en-US';
  var T = {
    nl: {
      load: 'Analyseren...', bad: 'Kan dit bestand niet openen. Probeer WAV of MP3.', big: 'Te groot (max. 200 MB).',
      v1: 'Heel luid. Platforms zetten je flink zachter. Check of je master niet geplet klinkt.', v2: 'Luid. Normaal voor rap en trap. Platforms zetten je iets zachter.', v3: 'Precies rond het streamingniveau.', v4: 'Aan de zachte kant. Op YouTube en Apple Music klinkt je track zachter dan andere nummers.',
      tpw: 'True peak boven -1 dBTP: kans op vervorming na het omzetten naar MP3 of AAC. Spotify adviseert onder -1 dBTP, en onder -2 dBTP als je master luider is dan -14 LUFS.',
      clipw: '{n} keer clipping gevonden (meerdere samples op 0 dB achter elkaar).', corrw: 'Lage stereo-correlatie: je mix kan in mono (telefoonspeaker, club) dunner klinken.',
      down: '{d} dB zachter', up: '{d} dB harder', same: 'Blijft gelijk', tp: 'True peak', lra: 'Dynamiek (LRA)', st: 'Max short-term', plr: 'Peak tot loudness', corr: 'Stereo-correlatie', clips: 'Clipping', none: 'Geen',
      orig: 'Origineel', asp: 'Zoals op Spotify', play: 'Afspelen', pause: 'Pauze', ref: 'Referentie', you: 'Jouw master', diff: 'Verschil',
      bands: ['Sub', 'Bass', 'Laag-mid', 'Mid', 'Hoog-mid', 'Lucht'], badcode: 'Deze code klopt niet.', unlocked: 'Pro staat aan. Veel plezier!', file: 'Bestand'
    },
    en: {
      load: 'Analyzing...', bad: "Can't open this file. Try WAV or MP3.", big: 'Too large (max 200 MB).',
      v1: 'Very loud. Platforms will turn you down a lot. Check that your master isn\'t squashed.', v2: 'Loud. Normal for rap and trap. Platforms turn you down a bit.', v3: 'Right around streaming level.', v4: 'On the quiet side. On YouTube and Apple Music your track will sound quieter than others.',
      tpw: 'True peak above -1 dBTP: risk of distortion after MP3/AAC encoding. Spotify recommends below -1 dBTP, and below -2 dBTP if your master is louder than -14 LUFS.',
      clipw: '{n} clipping events found (several samples at 0 dB in a row).', corrw: 'Low stereo correlation: your mix may sound thinner in mono (phone speaker, club).',
      down: '{d} dB quieter', up: '{d} dB louder', same: 'Stays the same', tp: 'True peak', lra: 'Dynamics (LRA)', st: 'Max short-term', plr: 'Peak to loudness', corr: 'Stereo correlation', clips: 'Clipping', none: 'None',
      orig: 'Original', asp: 'As on Spotify', play: 'Play', pause: 'Pause', ref: 'Reference', you: 'Your master', diff: 'Difference',
      bands: ['Sub', 'Bass', 'Low-mid', 'Mid', 'High-mid', 'Air'], badcode: "That code doesn't work.", unlocked: 'Pro is on. Have fun!', file: 'File'
    }
  }[L];
  var PRO_HASH = ["689a8132c7e79fdaf1ff0c1e717896a457b981ab64c34e6c430fa8b3936ef0a8", "aeaa76d70fa3cd026b665d5cc9b189c6d35f21a0b8535d1c359c2303c88f303a"], SALT = 'notb-mc|', KEY = 'notb_mc_pro';
  var hide = document.createElement('style'); hide.textContent = 'shopify-chat{display:none!important}'; document.head.appendChild(hide);

  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return root.querySelectorAll(s); };
  var drop = $('[data-mc-drop]'), status = $('[data-mc-status]'), res = $('[data-mc-res]');
  var proBox = $('[data-mc-probox]'), proMsg = $('[data-mc-promsg]'), codeIn = $('[data-mc-code]'), skipBtn = $('[data-mc-skip]');
  var pro = false, main = null, ref = null, ac = null, src = null, playing = false, abMode = 'orig', startAt = 0, offset = 0;

  // ------------------------------------------------------------ pro
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function sha(s) {
    if (!window.crypto || !crypto.subtle) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(s)).then(function (b) { return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); });
  }
  function tryCode(code, silent) {
    var norm = (code || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); if (!norm) return Promise.resolve(false);
    return sha(SALT + norm).then(function (h) {
      if (PRO_HASH.indexOf(h) > -1) { pro = true; store(KEY, h); proUi(); if (!silent) { proMsg.textContent = T.unlocked; setTimeout(closePro, 1200); } return true; }
      if (!silent) proMsg.textContent = T.badcode; return false;
    });
  }
  function proUi() { root.classList.toggle('is-pro', pro); $$('[data-mc-badge]').forEach(function (b) { b.hidden = !pro; }); }
  var saved = store(KEY); if (saved && PRO_HASH.indexOf(saved) > -1) pro = true;
  (function () {
    var m = location.search.match(/[?&]pro=([^&#]+)/);
    if (m) { tryCode(decodeURIComponent(m[1]), false).then(function (ok) { if (ok) openPro(true); }); try { history.replaceState(null, '', location.pathname + location.hash); } catch (e) {} }
  })();
  var after = null;
  function openPro(okOnly, then, skip) {
    after = then || null; proBox.hidden = false; proMsg.textContent = okOnly ? T.unlocked : '';
    skipBtn.hidden = !skip; skipBtn.onclick = skip ? function () { closePro(); skip(); } : null;
    proBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); if (okOnly) setTimeout(closePro, 1600);
  }
  function closePro() { proBox.hidden = true; }
  function needPro(fn, skip) { if (pro) return fn(); openPro(false, fn, skip); }
  $('[data-mc-proclose]').addEventListener('click', closePro);
  $('[data-mc-unlock]').addEventListener('click', function () { tryCode(codeIn.value).then(function (ok) { if (ok && after) { var f = after; after = null; f(); } }); });
  codeIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); $('[data-mc-unlock]').click(); } });

  // ------------------------------------------------------------ helpers
  function f1(v) { return isFinite(v) ? v.toLocaleString(loc, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) : '-∞'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function ctx() { if (!ac) ac = new (window.AudioContext || window.webkitAudioContext)(); if (ac.state === 'suspended') ac.resume(); return ac; }
  function decode(file) {
    if (file.size > 200 * 1048576) return Promise.reject(new Error('big'));
    return file.arrayBuffer().then(function (ab) {
      var u = new Uint8Array(ab, 0, Math.min(ab.byteLength, 4096)), sr = 44100, s4 = function (o) { return String.fromCharCode(u[o], u[o + 1], u[o + 2], u[o + 3]); };
      if (s4(0) === 'RIFF') { for (var o = 12; o < u.length - 16;) { var sz = u[o + 4] | u[o + 5] << 8 | u[o + 6] << 16 | u[o + 7] << 24; if (s4(o) === 'fmt ') { sr = u[o + 12] | u[o + 13] << 8 | u[o + 14] << 16 | u[o + 15] << 24; break; } o += 8 + sz; } }
      else if (s4(0) === 'fLaC') sr = (u[18] << 12) | (u[19] << 4) | (u[20] >> 4);
      if (!(sr >= 8000 && sr <= 192000)) sr = 44100;
      var oc = new OfflineAudioContext(2, 1, sr); return new Promise(function (r, j) { oc.decodeAudioData(ab, r, j); });
    });
  }
  function run(file) {
    status.textContent = T.load;
    return decode(file).then(function (buf) {
      return new Promise(function (r) { setTimeout(r, 30); }).then(function () {
        var chs = []; for (var c = 0; c < buf.numberOfChannels; c++) chs.push(buf.getChannelData(c));
        var a = NMASTER.analyze(chs, buf.sampleRate); a.name = file.name; a.buf = buf; return a;
      });
    }).then(function (a) { status.textContent = ''; return a; }, function (e) { status.textContent = e && e.message === 'big' ? T.big : T.bad; throw e; });
  }

  // ------------------------------------------------------------ render
  function verdict(a) { return a.lufs > -9 ? ['hot', T.v1] : a.lufs > -13 ? ['loud', T.v2] : a.lufs >= -15.5 ? ['ok', T.v3] : ['soft', T.v4]; }
  function metric(label, val, cls) { return '<div class="mc-m ' + (cls || '') + '"><span>' + label + '</span><b>' + val + '</b></div>'; }
  function render() {
    if (!main) { res.hidden = true; return; }
    var a = main, v = verdict(a), warns = [];
    if (a.tp > -1) warns.push(T.tpw);
    if (a.clips) warns.push(T.clipw.replace('{n}', a.clips));
    if (a.corr < 0.2) warns.push(T.corrw);
    $('[data-mc-name]').textContent = a.name;
    $('[data-mc-lufs]').textContent = f1(a.lufs);
    $('[data-mc-big]').className = 'mc-big is-' + v[0];
    $('[data-mc-verdict]').textContent = v[1];
    $('[data-mc-metrics]').innerHTML =
      metric(T.tp, f1(a.tp) + ' dBTP', a.tp > -1 ? 'is-warn' : 'is-ok') +
      metric(T.lra, f1(a.lra) + ' LU') +
      metric(T.st, f1(a.stMax) + ' LUFS') +
      metric(T.plr, f1(a.tp - a.lufs) + ' dB') +
      metric(T.corr, a.corr.toLocaleString(loc, { maximumFractionDigits: 2, minimumFractionDigits: 2 }), a.corr < 0.2 ? 'is-warn' : '') +
      metric(T.clips, a.clips ? String(a.clips) : T.none, a.clips ? 'is-warn' : 'is-ok');
    $('[data-mc-warns]').innerHTML = warns.map(function (w) { return '<li>' + w + '</li>'; }).join('');
    $('[data-mc-plat]').innerHTML = NMASTER.platforms(a).map(function (p) {
      var g = Math.round(p.gain * 10) / 10, txt = g < -0.05 ? T.down.replace('{d}', f1(-g)) : g > 0.05 ? T.up.replace('{d}', f1(g)) : T.same;
      return '<li><span>' + p.n + '</span><b class="' + (g < -0.05 ? 'is-down' : g > 0.05 ? 'is-up' : '') + '">' + txt + '</b></li>';
    }).join('');
    drawCurve();
    renderRef();
    res.hidden = false;
  }
  function drawCurve() {
    var cv = $('[data-mc-curve]'), g = cv.getContext('2d'), W = cv.width, H = cv.height, lo = -30, hi = -4;
    g.clearRect(0, 0, W, H);
    function y(v) { return H - (Math.max(lo, Math.min(hi, v)) - lo) / (hi - lo) * H; }
    g.strokeStyle = '#d1dfdf'; g.lineWidth = 1; g.font = Math.round(W / (cv.clientWidth || W) * 12) + 'px sans-serif'; g.fillStyle = '#4f6f74';
    [-24, -18, -14, -8].forEach(function (l) { g.beginPath(); g.moveTo(0, y(l)); g.lineTo(W, y(l)); g.stroke(); g.fillText(l + ' LUFS', 6, y(l) - 4); });
    g.strokeStyle = '#d68126'; g.setLineDash([6, 5]); g.beginPath(); g.moveTo(0, y(-14)); g.lineTo(W, y(-14)); g.stroke(); g.setLineDash([]);
    function line(c, col, w) {
      if (!c || !c.length) return; g.strokeStyle = col; g.lineWidth = w; g.beginPath();
      c.forEach(function (v, i) { var x = i / Math.max(1, c.length - 1) * W; if (i) g.lineTo(x, y(v)); else g.moveTo(x, y(v)); }); g.stroke();
    }
    if (ref) line(ref.curve, '#9dbfc2', 2);
    line(main.curve, '#013945', 2.5);
  }
  function renderRef() {
    var box = $('[data-mc-refres]');
    if (!ref) { box.hidden = true; return; }
    var rows = [['LUFS', main.lufs, ref.lufs], [T.tp, main.tp, ref.tp], [T.lra, main.lra, ref.lra], [T.st, main.stMax, ref.stMax], [T.plr, main.tp - main.lufs, ref.tp - ref.lufs]];
    var h = '<table class="mc-tab"><thead><tr><th></th><th>' + T.you + '</th><th>' + esc(T.ref) + '</th><th>' + T.diff + '</th></tr></thead><tbody>' +
      rows.map(function (r) { var d = r[1] - r[2]; return '<tr><td>' + r[0] + '</td><td>' + f1(r[1]) + '</td><td>' + f1(r[2]) + '</td><td class="' + (Math.abs(d) > 2 ? 'is-warn' : '') + '">' + (d > 0 ? '+' : '') + f1(d) + '</td></tr>'; }).join('') + '</tbody></table>';
    h += '<p class="mc-sub">' + (L === 'nl' ? 'Klankbalans: jouw master vergeleken met de referentie' : 'Tonal balance: your master vs the reference') + '</p><div class="mc-bands">' +
      T.bands.map(function (b, i) {
        var d = main.bands[i] - ref.bands[i], w = Math.min(50, Math.abs(d) * 8);
        return '<div class="mc-band"><span>' + b + '</span><div class="mc-bar"><i class="' + (d >= 0 ? 'is-pos' : 'is-neg') + '" style="width:' + w + '%;' + (d >= 0 ? 'left:50%' : 'right:50%') + '"></i></div><b>' + (d > 0 ? '+' : '') + f1(d) + ' dB</b></div>';
      }).join('') + '</div>';
    box.innerHTML = h; box.hidden = false;
  }

  // ------------------------------------------------------------ A/B playback (free)
  function stop() { if (src) { try { src.onended = null; src.stop(); } catch (e) {} src = null; } playing = false; $('[data-mc-play]').textContent = T.play; $('[data-mc-play]').setAttribute('aria-pressed', 'false'); }
  function gainFor() { if (abMode === 'orig') return 1; var sp = NMASTER.platforms(main)[0]; return Math.pow(10, sp.gain / 20); }
  var gn = null;
  function play() {
    var c = ctx(); stop();
    src = c.createBufferSource(); src.buffer = main.buf; gn = c.createGain(); gn.gain.value = gainFor();
    src.connect(gn); gn.connect(c.destination);
    startAt = c.currentTime - offset; src.start(0, offset % main.buf.duration);
    src.onended = function () { stop(); offset = 0; };
    playing = true; $('[data-mc-play]').textContent = T.pause; $('[data-mc-play]').setAttribute('aria-pressed', 'true');
  }
  $('[data-mc-play]').addEventListener('click', function () { if (!main) return; if (playing) { offset = ctx().currentTime - startAt; stop(); } else play(); });
  $$('[data-mc-ab]').forEach(function (b) {
    b.addEventListener('click', function () {
      abMode = b.getAttribute('data-mc-ab');
      $$('[data-mc-ab]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (gn) gn.gain.setTargetAtTime(gainFor(), ctx().currentTime, 0.03);
    });
  });

  // ------------------------------------------------------------ inputs
  function load(file) {
    if (!file) return;
    stop(); offset = 0;
    run(file).then(function (a) { main = a; render(); }, function () {});
  }
  function isAudio(f) { return /^audio\//.test(f.type) || /\.(wav|mp3|m4a|aac|flac|ogg|opus|aif|aiff)$/i.test(f.name); }
  $('[data-mc-file]').addEventListener('change', function (e) { load(e.target.files[0]); e.target.value = ''; });
  ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
  drop.addEventListener('drop', function (e) {
    var fl = Array.prototype.filter.call(e.dataTransfer.files, isAudio); if (!fl.length) return;
    if (fl.length > 1) needPro(function () { batch(fl); }, function () { load(fl[0]); }); else load(fl[0]);
  });
  // reference (Pro)
  var refIn = $('[data-mc-reffile]');
  $('[data-mc-refbtn]').addEventListener('click', function () { needPro(function () { refIn.click(); }); });
  refIn.addEventListener('change', function () {
    var f = refIn.files[0]; refIn.value = ''; if (!f) return;
    run(f).then(function (a) { ref = a; ref.buf = null; render(); }, function () {});
  });
  // batch (Pro)
  var batchIn = $('[data-mc-batchfile]');
  $('[data-mc-batchbtn]').addEventListener('click', function () { needPro(function () { batchIn.click(); }); });
  batchIn.addEventListener('change', function () { var fl = Array.prototype.filter.call(batchIn.files, isAudio); batchIn.value = ''; if (fl.length) batch(fl); });
  function batch(fl) {
    var box = $('[data-mc-batch]'), rows = [];
    box.hidden = false;
    function draw() {
      box.innerHTML = '<table class="mc-tab"><thead><tr><th>' + T.file + '</th><th>LUFS</th><th>' + T.tp + '</th><th>LRA</th><th>Spotify</th></tr></thead><tbody>' +
        rows.map(function (r) {
          if (!r.a) return '<tr><td>' + esc(r.f.name) + '</td><td colspan="4">' + (r.err ? T.bad : T.load) + '</td></tr>';
          var sp = NMASTER.platforms(r.a)[0], g = Math.round(sp.gain * 10) / 10;
          return '<tr><td>' + esc(r.f.name) + '</td><td><b>' + f1(r.a.lufs) + '</b></td><td class="' + (r.a.tp > -1 ? 'is-warn' : '') + '">' + f1(r.a.tp) + '</td><td>' + f1(r.a.lra) + '</td><td>' + (g < -0.05 ? '-' + f1(-g) + ' dB' : g > 0.05 ? '+' + f1(g) + ' dB' : '0') + '</td></tr>';
        }).join('') + '</tbody></table>';
    }
    fl.forEach(function (f) { rows.push({ f: f }); });
    draw();
    var chain = Promise.resolve();
    rows.forEach(function (r) { chain = chain.then(function () { return run(r.f).then(function (a) { a.buf = null; r.a = a; }, function () { r.err = true; }).then(draw); }); });
  }
  proUi();
})();
